import { Toogle } from 'alurkerja-ui'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import React, { useMemo, useCallback } from 'react'

type EditBooleanProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditBoolean(props: EditBooleanProps) {
  const { index, element, currentElementState, setCurrentElementState } = props

  // Get the value from currentElementState, properly memoized
  const currentValue = useMemo(() => !!currentElementState[element], [currentElementState, element])

  // Memoize the onChange handler to prevent recreating it on each render
  const handleChange = useCallback(
    (value: string | number | boolean | undefined) => {
      // Use a functional update to ensure we're working with the latest state
      setCurrentElementState((prevState: any) => {
        // Only update if the value is actually different to prevent unnecessary renders
        if (!!prevState[element] === !!value) {
          return prevState
        }
        return {
          ...prevState,
          [element]: value,
        }
      })
    },
    [element, setCurrentElementState]
  )

  return React.useMemo(
    () => (
      <div key={index} className="p-3 py-2 flex gap-2 rounded-sm">
        <Toogle id={element} defaultValue={currentValue} onChange={handleChange} />
        <label htmlFor={`${element}`} className="select-none">
          {stringToTitleCase(element)}
        </label>
      </div>
    ),
    [index, element, currentValue, handleChange]
  )
}
